import React from "react";

const Validation = (validationType,value) => {

  let regex = "";
  let text = "";
  switch (validationType){
    case "varchar":
      regex = /[!"#$%&'()*+,-./¨:;?@[\\\]_`{|}]/;
      text = value.replace(regex,"");
      return text;
    break;
    case "int":
      regex = /[^0-9]/;
      text = value.replace(regex,"");
      return text;
    break;
    case "decimal":
      regex = /[^\d+(\.\d*)?$|^\.\d+$]/;
      text = value.replace(regex,"");
      return text;
    break;
    default:
      return value
  }

  };

export default Validation;